import * as React from "react";
import { Link as GatsbyLink } from "gatsby";
import { useIntl } from "react-intl";

const Link = React.forwardRef(({ href, target = "_blank", ...props }, ref) => {
  const { locale } = useIntl();
  const path = `/${locale}${href}`;

  if (href.startsWith("/")) {
    return <GatsbyLink to={path} {...props} ref={ref} />;
  }
  return (
    <a
      href={href}
      target={target}
      rel="noopener noreferrer"
      {...props}
      ref={ref}
    />
  );
});

export default Link;
